<template>
    <section class="about-us">
        <div class="layout-banner">
            <div class="banner_box"></div>
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">中保科技</div>
                    <div class="sm-text">致力成为“数字保险的智能中台”，科技让保险更简单，让家庭更美好</div>
                    <div class="line"></div>
                </div>
            </div>
            <Nav :activeIndex='"4"'></Nav>
        </div>
        <div :class="fix?'all-title fix':'all-title'">
            <ul class="w-1200">
                <li v-for="(item, index) in allMenuList" :key="index" :class="[index===activeMenu?'active':'']" @click="jump(index)">{{item.name}}</li>
            </ul>
        </div>
        <div id="scrollBox" class="applications-content">
            <div class="all-list do-jump" id="aboutUs">
                <p class="applications-title">关于中保</p>
                <p class="subhead">ABOUT ZHONGBAO</p>
                <p class="ta-l mb10 f16 c-grey6 w-1200 t-indent line-h">中保科技创立于2016年11月，17年完成数百万元天使轮融资，19年完成数千万元A轮融资。中保科技深耕于个人及家庭生活场景，打造了行业领先的线上化、数据化、智能化的数字保险智能中台，是国内一流、专业、创新的保险科技公司。中保科技的使命是“科技让保险更简单，让家庭更美好”。</p>
                <p class="ta-l mb10 f16 c-grey6 w-1200 t-indent line-h">中保科技核心团队源自国内知名头部险企总部高管及骨干，保险产品及保险系统开发从业经验丰富。创始人曾任头部险企非车第一大产品线总监，具有十年以上产品设计及运营经验，开辟了国内延保保险市场（联想、海尔、奔驰等），团队成员曾负责责任险、个财险、信用险等产品线全国经营，具有深厚的专业底蕴和项目经验。</p>
                <p class="ta-l mb10 f16 c-grey6 w-1200 t-indent line-h">中保科技拥有丰富的家庭生活产品矩阵，深厚的场景化产品经验，以及与行业场景深度结合的保险科技相关技术底蕴。目前中保科技的主打产品包括数码3C产品保险及服务（如手机碎屏保、家电延保）、宠物医疗健康保险及服务、家庭场景保险周边服务（维修、救援、清洗等增值服务）、汽车后市场保险及服务等，未来将不断围绕个人及家庭场景打造优质产品与服务。中保科技围绕细分产品输出从产品开发到营销推广到运营风控的全流程服务解决方案，打造了智能营销、智能核保、智能理赔、智能风控、智能数据五大核心智能中台模块，应用OCR识别、大数据、AI（鼻纹及人脸识别）、NLP等核心科技，赋能保险供应链上下游，实现精细化经营。</p>
                <p class="ta-l mb10 f16 c-grey6 w-1200 t-indent line-h">中保科技已累计合作15家主流财险公司，总对总签约，包括平安、阳光、太平、华安等。合作知名服务供应商数十家，覆盖行业知名企业及头部平台包括华为、小米、OPPO、支付宝、京东金融、移动、电信等，落地项目逾数十个，手机保险渠道合作覆盖率市场领先。</p>
                <!-- <p class="ta-c f18 c-grey6 w-1200">公司致力成为中国「服务类保险」产品“最大、最专业”的保险公司的服务提供商。</p> -->
                <Mission></Mission>
            </div>
            <div class="all-list do-jump clearfix bg-lightBlue" id="news">
                <p class="applications-title">新闻资讯</p>
                <p class="subhead">NEWS INFORMATION</p>
                <News :type="2"></News>
            </div>
            <div class="all-list do-jump" id="cooperation">
                <p class="applications-title">商务合作</p>
                <p class="subhead">BUSINESS COOPERATION</p>
                <Cooperation></Cooperation>
            </div>
            <div class="all-list do-jump pb60" id="joinUs" style="height:658px;">
                <Particles :particlesId="'particles-about'"></Particles>
                <p class="applications-title">加入我们</p>
                <p class="subhead">JOIN US</p>
                <p class="ta-c f18 c-grey6 w-1200 mb20">如果下面这些文字让你有所憧憬，欢迎发送简历到<br><span class="hr">hr@zhongbaojinfu.com.cn</span></p>
                <ul class="tech-accordion w-1200">
                    <li :class="[{active:item.show}]" @mouseenter="changeli(item,i)" v-for="(item,i) in recruitmentList" :key="i">
                        <div class="accord-content">
                            <h2>{{item.name}}</h2>
                            <p class="term-item" v-html="item.describe">
                            </p>
                            <!-- <span class="btn">查看详情</span> -->
                        </div>
                        <div class="accord-title-box">
                            <div class="accord-title">
                                <img :src=item.src alt="">
                                <div class="text-part">{{item.name}} </div>
                                <div class="ink-bar"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <Footer :isSelf="true"></Footer>
        <Cornerbar :isSelf="true"></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Mission from '@/components/Mission'
import News from '@/components/News'
import Cooperation from '@/components/Cooperation'
import Particles from '@/components/Particles'
import Cornerbar from '@/components/Cornerbar'
export default {
  name: 'home',
  components: {
    Nav,
    Footer,
    Mission,
    News,
    Cooperation,
    Particles,
    Cornerbar
  },
  data () {
    return {
      activeMenu: 0,
      fix: false,
      allMenuList: [{ name: '关于中保' }, { name: '新闻资讯' }, { name: '商务合作' }, { name: '加入我们' }],
      recruitmentList: [
        { name: 'Web前端', src: require('../../assets/icon/web.png'), show: true, describe: '岗位职责：<br>1.负责产品前端功能设计、开发、测试和调优；<br>2. 前端基础框架和组件的开发和维护；<br>3.参与或者负责公司产品的前端核心模块的架构设计和开发；' },
        { name: 'Java', src: require('../../assets/icon/java.png'), show: false, describe: '岗位职责：<br>1.负责公司各项目开发，对已有项目的维护；<br>2. 能快速定位和解决系统运行中出现的问题缺陷；<br>3.规范文档的编写、维护，以及其他与项目相关工作；<br>4.配合实施公司业务需求；' },
        { name: '大客户代表', src: require('../../assets/icon/bd.png'), show: false, describe: '岗位职责：<br>1.负责企业端渠道合作项目，达成公司售后服务产品的BD/KA工作；<br>2. 积极协调公司内部团队及资源为客户服务，承接重点项目、渠道的运营维护等相关工作，达成业绩目标；' },
        { name: '客服', src: require('../../assets/icon/kefu.png'), show: false, describe: '岗位职责：<br>1.通过电话和运营系统解决客户的售后咨询和理赔服务，衔接供应商服务，提供售前服务销售咨询；<br>2. 要求一定要有“客户为先”的服务精神，一切从帮助客户、满足客户角度出发；' }]
    }
  },
  methods: {
    jump (index) {
      this.activeMenu = index // 当前导航
      const jump = document.getElementsByClassName('do-jump')[index]
      let height = Number(document.getElementsByClassName('all-title')[0].offsetHeight) // 导航的高度
      let scrollTop
      if (this.fix) {
        scrollTop = jump.offsetTop - height // 获取需要滚动的距离
      } else {
        scrollTop = jump.offsetTop - height * 2 // 获取需要滚动的距离
      }
      // Chrome
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth' // 平滑滚动
      })
    },
    changeli (item, num) {
      this.recruitmentList.forEach(i => {
        // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么headerData[i]等于false
        if (i.show !== this.recruitmentList[num].show) {
          i.show = false
        };
      })
      // 取反(true或false)
      item.show = true
    },
    getlocal () {
      let id = localStorage.getItem('id')
      if (id) {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
        this.activeMenu = 2
      }
    }
  },
  mounted () {
    // 监听dom元素的scroll事件
    window.addEventListener('scroll', () => {
      if (document.getElementById('scrollBox')) {
        const height = document.getElementById('scrollBox').offsetTop - Number(document.getElementsByClassName('all-title')[0].offsetHeight)
        if (window.scrollY > height) {
          this.fix = true
        } else {
          this.fix = false
        }
      }
    }, true)
  },
  created () {
    this.$nextTick(() => {
      this.getlocal()
    })
  },
  destroyed () {
    window.removeEventListener('scroll', () => {})
    localStorage.setItem('id', '')
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.about-us{
    .layout-banner{
        position: relative;
        height: 580px;
        overflow: hidden;
    }
    .banner_box{
        background: url(../../assets/banner8.png) 100% no-repeat;
        width: 100%;
        height: 580px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        animation: transform1 6s linear 0s forwards;
    }
    .banner{
        // background: url(../../assets/banner8.png) 100% no-repeat;
        // transition: all 7.6s cubic-bezier(0.04, 0.79, 1, 1) !important;
        // transform: scale(1.02);
        position: absolute;
        top: 0;
        width: 100%;
        height: 580px;
        overflow: hidden;
        // background-repeat: no-repeat;
        // background-position: center center;
        // background-color: #0b0f1a;
        .banner-text{
            font-family: 'SourceHanSansCN-Regular';
            margin: 0 auto;
            padding-top: 189px;
            animation-duration: 2.5s;
            .big-text{
                color: #fff;
                height: 67px;
                font-size: 36px;
                line-height: 67px;
                letter-spacing: 1px;
                font-weight: bold;
            }
            .sm-text{
                margin-top: 15px;
                margin-bottom: 30px;
                line-height: 30px;
                font-size: 18px;
                font-weight:400;
                letter-spacing: 1px;
                color: #E5E5E5;
            }
            .line{
                width: 64px;
                height: 5px;
                background: #fff;
            }
        }
    }
    .all-title{
        box-shadow: 10px 10px 13px -16px #888;
        height: 67px;
        background: #fff;
        width: 100%;
        &.fix{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9;
        }
        ul{
            padding: 0;
            margin: 0 auto;
            text-align: center;
        li{
            color: #666;
            padding: 17px 0;
            margin: 0 40px;
            display: inline-block;
            font-size: 14px;
            cursor: pointer;
            &.active{
                border-bottom: 2px solid #007dff;
                color: #333;
            }
        }
        }
    }
    .all-list{
        position: relative;
        &.bg-img{
            // height: 843px;
            background: url(../../assets/solution_finance_bg.png) 50% no-repeat;
            color: #fff;
        }
        .applications-title{
            display: block;
            text-align: center;
            font-weight: 700;
            // padding: 60px 0 30px 0;
            padding-top: 60px;
            font-size: 28px;
            line-height: 30px;
            color: #333;
            // &:hover{
            //     &::after{
            //         width: 120px;
            //     }
            // }
            // &::after{
            //     content: '';
            //     display: block;
            //     width: 45px;
            //     height: 4px;
            //     background: #007dff;
            //     margin: 27px auto 0;
            //     transition: all 0.3s;
            // }
        }
        .subhead{
            font-size: 14px;
            color: #ccc;
            line-height: 24px;
            text-transform: uppercase;
            margin-top: 5px;
            padding-bottom: 30px;
            text-align: center;
            letter-spacing:1px;
        }
        &>p{
            margin: 0 auto;
            .hr{
                display: inline-block;
                font-size: 16px;
                padding: 0 20px;
                margin-top: 10px;
                color: #007dff;
                margin-bottom: 20px;
            }
        }
        .tech-accordion{
            display: block;
            font-size: 0;
            line-height: 352px;
            margin: 0 auto;
            overflow: hidden;
            li{
                vertical-align: middle;
                display: inline-block;
                cursor: pointer;
                margin-right: 12px;
                width: 220px;
                transition: width 0.5s linear;
                &.active{
                    width: 462px;
                    .accord-content{
                        display: block;
                    }
                    .accord-title-box{
                         display: none;
                    }
                }
                .accord-content {
                    border-radius: 4px;
                    display: none;
                    height: 352px;
                    width: 462px;
                    padding: 30px;
                    background-color: #3E9DFF;
                    color: #ffffff;
                    line-height: 22px;
                    &>h2{
                        font-size: 26px;
                        font-weight: 500;
                        color: #ffffff;
                        margin: 71px 0 24px 0;
                        padding-left: 20px;
                    }
                    .term-item {
                        position: relative;
                        color: #ffffff;
                        font-size: 14px;
                        padding-left: 20px;
                    }
                    .btn{
                        display: inline-block;
                        padding: 5px 12px;
                        border: 1px solid #fff;
                        cursor: pointer;
                        font-size:14px;
                        margin-top: 20px;
                        margin-left: 20px;
                    }
                }
                .accord-title-box {
                    position: relative;
                    height: 352px;
                    border-radius: 4px;
                    width: 220px;
                    background-image: url(../../assets/title_bg.png);
                    background-size: 100% 100%;
                    background-position: center center;
                    background-repeat: no-repeat;
                    .accord-title {
                        position: absolute;
                        bottom: 45px;
                        left: 28px;
                        img{
                            width: 35px;
                            display: block;
                            margin-bottom: 12px;
                        }
                        .text-part {
                            font-size: 26px;
                            font-weight: 500;
                            color: #ffffff;
                            line-height: 28px;
                        }
                        .ink-bar {
                            margin-top: 13px;
                            background-color: #3E9DFF;
                            width: 52px;
                            height: 8px;
                        }
                    }
                }
            }
        }
    }
}
</style>
